import { useaxios } from "../../../../utils/useaxios";
export default (boss_income_nameandpurpose, boss_income_amount, boss_income_invoiceno, boss_income_note, boss_income_date, boss_income_id) => setloading => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    setloading(true);
    useaxios('boss_income/update.php', { boss_income_nameandpurpose, boss_income_amount, boss_income_invoiceno, boss_income_note, boss_income_date, boss_income_id }).then((res) => {
        console.log(res);
        if (res.status == "ok") {
        } else {
            // clear();
        }
        setloading(false);
    });
}